import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { TYPES } from '../../_constants/types'
import { getActionsForEntity } from '../../_constants/actions'
import { useForm } from '../../../../packages/kiti/components/form/form/FormHandler'
import { useModalData } from '../../../../components/modals/ModalsContext'
import ButtonPicker from '../../../../packages/kiti/components/form/ButtonPicker'
import DateInput from '../../../../components/form/date/DateInput'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import NumberInput from '../../../../components/form/NumberInput'
import Select from '../../../../packages/kiti/components/form/Select'
import Textarea from '../../../../packages/kiti/components/form/Textarea'

const GeneralSection = () => {
  const { t } = useTranslation(['publicToken', 'common'])
  const data = useModalData() || {}

  const form = useForm()

  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="50%" wrapOn="sm">
        <FormItem label={t('common:name')} field="name" />
      </Col>

      <Col width="50%" wrapOn="sm">
        <FormItem
          label={t('publicToken:action')}
          field="action"
          Input={Select}
          options={getActionsForEntity(data.entity)}
          selectOnlyId
        />
      </Col>

      <Col width="50%" wrapOn="sm">
        <FormItem label={t('publicToken:maxExecution')} field="amountLeft" Input={NumberInput} />
      </Col>

      <Col width="50%" wrapOn="sm">
        <FormItem label={t('publicToken:expiresAt')} field="expireDate" Input={DateInput} useTime />
      </Col>

      <Col width="100%" wrapOn="sm">
        <FormItem label={t('publicToken:usageType')} field="type" Input={ButtonPicker} options={TYPES} selectOnlyId />
      </Col>

      {form.type === 'rest' && (
        <>
          <Col width="100%" wrapOn="sm">
            <FormItem label={t('publicToken:conditions')} field="conditions" Input={Textarea} api />
          </Col>

          <Col width="100%" wrapOn="sm">
            <FormItem label={t('publicToken:payload')} field="payload" Input={Textarea} />
          </Col>
        </>
      )}
    </Grid>
  )
}

export default GeneralSection
